import { Injectable, ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { Globals } from '../../../globals';
import {tap} from 'rxjs/operators';
import {LoginResponseModel} from './login-response.model';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(private http: HttpClient, private globals: Globals) { }
  loginurl = '';

  public getAuthApi(usr: any, ps: any, locid: any, workstation: any): Observable<LoginResponseModel> {

    // this needs to come from the service broker
    // can't seem to find where this is getting called from.. it's referenced by login.component.ts,
    // but ngOnInit doesn't seem to be getting executed from there
    workstation = 'WSTEST';

    const data = `username=${usr}&password=${ps}&grant_type=password&callingapp=TDOX&LOCID=${locid}&workstation=${workstation}`;
    localStorage.setItem('LOCID', locid);
    this.globals.LOCID = locid;
    //var data = `username=${usr}&password=${ps}&grant_type=password&callingapp=TDOX`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    return this.http.post<LoginResponseModel>(this.loginurl + '/token', data, httpOptions)
      .pipe(tap (_ => {
        localStorage.setItem('TDOCID', _.TDOCID);
        this.globals.TDOCID = _.TDOCID;
        this.globals.LOCenumCountryId = _.enumCountryID;
      }));
  }

  public userLogin(username: string, password: string, locid: string): Observable<any> {
    const params = new HttpParams({
      fromObject: {
        grant_type: 'password',
        username: username,
        password: password,
        callingapp: 'TDOX',
        LOCID: locid,
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    return this.http.post<any>('/token', params, httpOptions);
  }

  public getLocations(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.get<any>('/api/general/getLocationsFromURL', httpOptions);
  }
}
